module.exports = __webpack_public_path__ + "static/media/logo-white.43e944c9.png";